import { useMemo } from 'react';
import { PremiumSessionUserFacingStatus } from 'types/premiumSession';

const usePremiumSessionLegends = (extraSessionInfoMap) => {
  const legendsData = useMemo(() => {
    const legendsDict = {
      [PremiumSessionUserFacingStatus.Attended]: 0,
      [PremiumSessionUserFacingStatus.Enrolled]: 0,
      [PremiumSessionUserFacingStatus.Requested]: 0,
      [PremiumSessionUserFacingStatus.Schedulable]: 0,
      [PremiumSessionUserFacingStatus.Unavailable]: 0,
    };
    extraSessionInfoMap.forEach((value) => {
      if (typeof value.userFacingStatus === 'string') {
        if (typeof legendsDict[value.userFacingStatus] === 'number') {
          legendsDict[value.userFacingStatus] += 1;
        } else {
          legendsDict[value.userFacingStatus] = 1;
        }
      }
    });
    return legendsDict;
  }, [extraSessionInfoMap]);

  return legendsData;
};

export default usePremiumSessionLegends;
